import { Car, Users, RefreshCw, Leaf, Wallet, ShieldCheck } from "lucide-react";

const features = [
  {
    icon: Car,
    title: "Post Your Trip",
    desc: "Driving from Delhi to Gurgaon? Post your route, set seats and price — earn while you commute.",
    accent: "green",
    span: "lg:col-span-7",
  },
  {
    icon: Users,
    title: "Find a Pool",
    desc: "Browse verified trip hosts heading your way. Book a seat in two taps.",
    accent: "dark",
    span: "lg:col-span-5",
  },
  {
    icon: RefreshCw,
    title: "Switch Roles in 10 mins",
    desc: "Be a co-traveller this morning, host a trip in the evening. RideMate is the only app where roles flip in under 10 minutes.",
    accent: "green",
    span: "lg:col-span-5",
    highlight: true,
  },
  {
    icon: Wallet,
    title: "Save up to 60%",
    desc: "Split fuel and tolls. Daily commuters save thousands every month.",
    accent: "dark",
    span: "lg:col-span-4",
  },
  {
    icon: Leaf,
    title: "Greener Cities",
    desc: "Every shared seat takes a car off the road. Ride for the planet.",
    accent: "green",
    span: "lg:col-span-3",
  },
  {
    icon: ShieldCheck,
    title: "Verified Community",
    desc: "ID-verified hosts, in-app chat, two-way ratings, and 24×7 support.",
    accent: "dark",
    span: "lg:col-span-12",
  },
];

const accentMap = {
  green: { text: "text-[#5FA836]", iconBg: "bg-[#5FA836]/10" },
  dark: { text: "text-[#24303F]", iconBg: "bg-[#24303F]/8" },
};

export default function Features() {
  return (
    <section
      id="features"
      data-testid="features-section"
      className="relative py-28 md:py-36 bg-white"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-3xl reveal">
          <span className="font-display text-[11px] uppercase tracking-[0.25em] text-[#5FA836] font-bold">
            Why RideMate
          </span>
          <h2 className="mt-4 font-display text-4xl md:text-6xl font-black tracking-[-0.03em] leading-tight text-[#24303F]">
            Built for the way <br />
            <span className="text-gray-400">India actually</span> commutes.
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-12 gap-5">
          {features.map((f, i) => {
            const Icon = f.icon;
            const accent = accentMap[f.accent];
            return (
              <div
                key={i}
                data-testid={`feature-card-${i}`}
                className={`reveal lift relative ${f.span} rounded-3xl border border-[#e5e7eb] bg-[#F9FAFB] p-7 md:p-9 overflow-hidden`}
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                {f.highlight && (
                  <div className="absolute top-5 right-5 font-display text-[10px] uppercase tracking-[0.25em] text-[#5FA836] font-bold border border-[#5FA836]/40 rounded-full px-2.5 py-1 bg-[#5FA836]/10">
                    USP
                  </div>
                )}
                <div className={`h-11 w-11 rounded-xl ${accent.iconBg} grid place-items-center ${accent.text}`}>
                  <Icon className="w-5 h-5" strokeWidth={2} />
                </div>
                <h3 className="mt-6 font-display text-2xl md:text-3xl font-bold tracking-tight text-[#24303F]">
                  {f.title}
                </h3>
                <p className="mt-3 font-body text-gray-600 text-[15px] leading-relaxed">
                  {f.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
